<div
  class="bg-gray-50 rounded-full  col-span-12 p-1 w-full  md:flex-row justify-end gap-3 md:gap-0">
  <div class="flex flex-wrap">
    @for (menu of tabItems; track $index) {
      @if (menu?.slug === activeSlug) {
        @if(menu?.permissions?.length){
          <button
            *ngxPermissionsOnly="menu?.permissions"
            [ngClass]="{ 'text-primary-500': !isKiosk, 'text-hpc-primary': isKiosk }"
            class="px-3 py-2 border-2 rounded-full border-gray-100 bg-white  font-bold grow md:grow-0 delay-75 duration-200 ease-out hover:ease-in transition-all">
            {{ menu.title | translate }}
            <span class="p-1 px-2 ml-1 bg-white  rounded-full border-gray-300 border-2"
                  *ngIf="menu?.count">{{ menu?.count }}</span>
          </button>
        } @else {
          <button
            [ngClass]="{ 'text-primary-500': !isKiosk, 'text-hpc-primary': isKiosk }"
            class="px-3 py-2 border-2 rounded-full border-gray-100 bg-white font-bold grow md:grow-0 delay-75 duration-200 ease-out hover:ease-in transition-all">
            {{ menu.title | translate }}
            <span class="p-1 px-2 ml-1 bg-white  rounded-full border-gray-300 border-2"
            *ngIf="menu?.count">{{ menu?.count }}</span>
          </button>
        }
      } @else {
        @if(menu?.permissions?.length){
          <button
            [ngClass]="{ 'hover:text-primary-500': !isKiosk, 'hover:text-hpc-primary': isKiosk }"
            *ngxPermissionsOnly="menu?.permissions"
            (click)="activeSlug = menu.slug; activeIndex=$index; selectTab();"
            class="px-3 py-2 grow text-gray-500 md:grow-0  ease-out hover:ease-in transition-all duration-200">
            {{ menu.title | translate }}
            <span class="p-1 px-2 ml-1 bg-white  rounded-full border-gray-300 border-2"
                  *ngIf="menu?.count">{{ menu?.count }}
            </span>
          </button>
        } @else {
          <button
            [ngClass]="{ 'hover:text-primary-500': !isKiosk, 'hover:text-hpc-primary': isKiosk }"
            (click)="activeSlug = menu.slug; activeIndex=$index; selectTab();"
            class="px-3 py-2 grow text-gray-500 md:grow-0  ease-out hover:ease-in transition-all duration-200">
            {{ menu.title | translate }}
            <span class="p-1 px-2 ml-1 bg-white  rounded-full border-gray-300 border-2"
                  *ngIf="menu?.count">{{ menu?.count }}
            </span>
          </button>
        }

      }
    }
  </div>
</div>
